module.exports = __webpack_public_path__ + "static/media/icon.f43f1d23.png";